import React, { useContext, useEffect, useState } from 'react';
import { useFormikContext } from 'formik';

import * as ES from '../donneesFilieres/filiereES';
import * as S from '../donneesFilieres/filiereS';
import * as L from '../donneesFilieres/filiereL';
import * as STMG from '../donneesFilieres/filiereSTMG';

// import { BoutonAnnulerModifications } from './boutons/interfacePrincipale/boutonAnnulerModifications';
// import { BoutonValiderModifications } from './boutons/interfacePrincipale/boutonValiderModifications';
import { BoutonEtapeSuivante } from './boutons/interfacePrincipale/boutonEtapeSuivante';
import { BoutonRetour } from './boutons/interfacePrincipale/boutonRetour';

import {
  EtapesSaisieContext,
  ResponsiveContext,
  KeyboardContext,
} from '../App';
import {
  Simulation,
  OptionsBouton,
  Matiere,
  COEF_OPTION1_LATIN_GREC, COEF_OPTION1, COEF_OPTION2, tabNotesOptions, simulationBaseNotesVide, SimulationBaseNotes, NotesTrimestreVide, NotesTrimestre,
} from '../types/main';
import { SaisieNoteCC } from './fenetresSaisie/saisieNoteCC';
import { BarreProgression } from './autres/barreProgression';
import { PointsNote } from './autres/points';
import { updateSimulationInLocalStorage, getSimulationInLocalStorage } from '../utils/localStorage';
import { decodeShareCode } from '../utils/utils';


export interface SaisieContextProps {
  modeAffichage: boolean;
  setModeAffichage: (modeAffichage: boolean) => void;
  setArrowRightPressed: (arrowRightPressed: boolean) => void;
  setArrowLeftPressed: (arrowLeftPressed: boolean) => void;
  boutonSuivant: OptionsBouton;
  setBoutonSuivant: (boutonSuivant: OptionsBouton) => void;
}
export const SaisieContext = React.createContext({} as SaisieContextProps);
SaisieContext.displayName = 'SaisieContext';

export const FormConteneur: React.FC = () => {
  const etapesSaisieContextProps = useContext(EtapesSaisieContext);
  const { indexRubriqueSaisie, indexEtapeDansRubrique, etapesSaisie,
    changeAffichage,
    nextEtapeSaisie, previousEtapeSaisie,
    // setEtapesSaisie,
    // setEcranChargement,
    popupAffiche, closePopup, popupCloseClass,
    nbEtapesSaisie, directToEtapeSaisie,
    changeEtapes, modifIndexes, setModifIndexes,
    setChampInvalide, setSimulationLS,
  } = etapesSaisieContextProps;
  const { setEscapeDown } = useContext(KeyboardContext);
  const { pageUnmount, dimensions } = useContext(ResponsiveContext);
  const [composantAAfficher, setComposantAAfficher] = useState<JSX.Element | null>(null);
  const [modeAffichage, setModeAffichage] = useState(false);
  const [arrowRightPressed, setArrowRightPressed] = useState(false);
  const [arrowLeftPressed, setArrowLeftPressed] = useState(false);
  const [boutonSuivant, setBoutonSuivant] = useState<OptionsBouton>('non');
  const [matieresEA, setMatieresEA] = useState<Matiere[]>([]);
  const [matieres, setMatieres] = useState<Matiere[]>([]);
  const [options, setOptions] = useState(tabNotesOptions);
  const [fromFB, setFromFB] = useState(false);
  // const [etapesBaseOptions, setEtapesBaseOptions] = useState<EtapeSaisie[]>(EtapesBaseOptions);
  
  const { setFieldValue, values, setValues } = useFormikContext();
  const simulation = values as Simulation ;
  const {
    filiere, sous_filiere,
    specialite,
    nb_options, latin_ou_grec,
    option_1, option_2,
    // points, nbTotalPoints,
  } = simulation;

  const _changeEtapes = (_matieres: Matiere[], numRubrique: number): void => {
    const _etapesMatieres = _matieres.map((matiere) => {
      return {
        composant: <SaisieNoteCC
          name={matiere.name}
          label={matiere.label}
          coef={matiere.coef}
          spe={matiere.spe ? true : false}
          pointsAuDessus10={!!matiere.pointsAuDessus10}
          noteUnique={numRubrique === 1}
        />,
        afficher: matiere.coef !== 0,
      };
    });
    switch (numRubrique) {
      case 1:
        setMatieresEA(_matieres);
        break;
      case 2:
        setMatieres(_matieres);
        break;
      case 3:
        setOptions(_matieres);
        // _etapesMatieres = etapesBaseOptions.concat(_etapesMatieres);
        break;
      default:
        break;
    }
    changeEtapes(_etapesMatieres, numRubrique);
  }

  useEffect(() => {
    const url = new URL(window.location.href);
    const code = url.searchParams.get('code');
    let vals = null;
    if (code) {
      vals = decodeShareCode(code);
      // console.log('vals =', vals);
    }
    if (vals) {
      setFromFB(true);
      // console.log('vals =', vals);
      setFieldValue('filiere', vals.f ? vals.f : '');
      setFieldValue('points', vals.p ? vals.p : 0);
      setFieldValue('nbTotalPoints', vals.n ? vals.n : 1);
      const nb = etapesSaisie.length;
      directToEtapeSaisie(nb - 1, etapesSaisie[nb - 1].etapes.length - 1);
    } else {
      if (filiere !== '') {
        const simuToStore = getSimulationInLocalStorage(filiere);
        if (simuToStore) setValues(simuToStore);
      }
      // console.log('useEffect de FormConteneur filiere =', filiere);
      let _matieresEA;
      switch (filiere) {
        case 'ES':
          _matieresEA = ES.matieres_EA_ES;
          changeAffichage(0, 1, false);
          changeAffichage(0, 2, true);
          break;
        case 'S':
          _matieresEA = S.matieres_EA_S;
          changeAffichage(0, 1, true);
          changeAffichage(0, 2, true);
          break;
        case 'L':
          _matieresEA = L.matieres_EA_L;
          changeAffichage(0, 1, false);
          changeAffichage(0, 2, true);
          break;
        // case 'STMG':
        //   _matieresEA = STMG.matieres_EA_STMG;
        //   _changeEtapes(STMG.matieres_STMG, 2);
        //   changeAffichage(0, 1, false);
        //   changeAffichage(0, 2, false);
        //   break;
        default:
          _matieresEA = [] as Matiere[];
          break;
      }

      _changeEtapes(_matieresEA, 1);
      // _changeEtapes(options, 3);
    }
  }, [filiere]);

  useEffect(() => {
    // console.log('useEffect de FormConteneur sous_filiere =', sous_filiere);
    if (indexRubriqueSaisie === 0 && indexEtapeDansRubrique === 1 && sous_filiere !== '') {
      nextEtapeSaisie();
    }
  }, [sous_filiere]);

  useEffect(() => {
    // console.log('useEffect de FormConteneur specialite. filiere=', filiere, 'specialite =', specialite);
    let _matieres;
    switch (filiere) {
      case 'ES':
        _matieres = [...ES.matieres_ES];
        switch (specialite) {
          case 'Economie approfondie':
            _matieres[1].coef = ES.COEF_MATHS_SIPASSPE;
            _matieres[2].coef = 0;
            _matieres[3].coef = ES.COEF_ECO_APP;
            _matieres[4].coef = 0;
            _matieres[1].spe = false;
            _matieres[2].spe = false;
            _matieres[3].spe = true;
            _matieres[4].spe = false;
            break;
          case 'Mathématiques':
            _matieres[1].coef = ES.COEF_MATHS_PASSPE_SI_SPE;
            _matieres[2].coef = ES.COEF_MATHS_SPE;
            _matieres[3].coef = 0;
            _matieres[4].coef = 0;
            _matieres[1].spe = false;
            _matieres[2].spe = true;
            _matieres[3].spe = false;
            _matieres[4].spe = false;
            break;
          case 'Sciences sociales et politiques':
            _matieres[1].coef = ES.COEF_MATHS_SIPASSPE;
            _matieres[2].coef = 0;
            _matieres[3].coef = 0;
            _matieres[4].coef = ES.COEF_SSP;
            _matieres[1].spe = false;
            _matieres[2].spe = false;
            _matieres[3].spe = false;
            _matieres[4].spe = true;
            break;
          default:
            _matieres = [] as Matiere[];
            break;
        }
        break;
      case 'S':
        _matieres = [...S.matieres_S];
        switch (sous_filiere) {
          case 'S-SVT':
            switch (specialite) {
              case 'Mathématiques':
                _matieres[0].coef = 9; // maths
                _matieres[1].coef = 6; // PC
                _matieres[2].coef = 6; // SVT
                _matieres[3].coef = 0; // EAT
                _matieres[4].coef = 0; // SI
                _matieres[5].coef = 0; // ISN
                _matieres[0].spe = true; // maths
                _matieres[1].spe = false; // PC
                _matieres[2].spe = false; // SVT
                _matieres[3].spe = false; // EAT
                // _matieres[4].spe = false; // SI jamais spé
                _matieres[5].spe = false; // ISN
                break;
              case 'Physique - Chimie':
                _matieres[0].coef = 7; // maths
                _matieres[1].coef = 8; // PC
                _matieres[2].coef = 6; // SVT
                _matieres[3].coef = 0; // EAT
                _matieres[4].coef = 0; // SI
                _matieres[5].coef = 0; // ISN
                _matieres[0].spe = false; // maths
                _matieres[1].spe = true; // PC
                _matieres[2].spe = false; // SVT
                _matieres[3].spe = false; // EAT
                // _matieres[4].spe = false; // SI jamais spé
                _matieres[5].spe = false; // ISN
                break;
              case 'SVT':
                _matieres[0].coef = 7; // maths
                _matieres[1].coef = 6; // PC
                _matieres[2].coef = 8; // SVT
                _matieres[3].coef = 0; // EAT
                _matieres[4].coef = 0; // SI
                _matieres[5].coef = 0; // ISN
                _matieres[0].spe = false; // maths
                _matieres[1].spe = false; // PC
                _matieres[2].spe = true; // SVT
                _matieres[3].spe = false; // EAT
                // _matieres[4].spe = false; // SI jamais spé
                _matieres[5].spe = false; // ISN
                break;
              case 'ISN':
                _matieres[0].coef = 7; // maths
                _matieres[1].coef = 6; // PC
                _matieres[2].coef = 6; // SVT
                _matieres[3].coef = 0; // EAT
                _matieres[4].coef = 0; // SI
                _matieres[5].coef = 2; // ISN
                _matieres[0].spe = false; // maths
                _matieres[1].spe = false; // PC
                _matieres[2].spe = false; // SVT
                _matieres[3].spe = false; // EAT
                // _matieres[4].spe = false; // SI jamais spé
                _matieres[5].spe = true; // ISN
                break;
              default:
                _matieres = [] as Matiere[];
                break;
            }
            break;
          case 'S-Écologie, agronomie et territoires':
            switch (specialite) {
              case 'Mathématiques':
                _matieres[0].coef = 9; // maths
                _matieres[1].coef = 6; // PC
                _matieres[2].coef = 0; // SVT
                _matieres[3].coef = 7; // EAT
                _matieres[4].coef = 0; // SI
                _matieres[5].coef = 0; // ISN
                _matieres[0].spe = true; // maths
                _matieres[1].spe = false; // PC
                _matieres[2].spe = false; // SVT
                _matieres[3].spe = false; // EAT
                // _matieres[4].spe = false; // SI jamais spé
                _matieres[5].spe = false; // ISN
                break;
              case 'Physique - Chimie':
                _matieres[0].coef = 7; // maths
                _matieres[1].coef = 8; // PC
                _matieres[2].coef = 0; // SVT
                _matieres[3].coef = 7; // EAT
                _matieres[4].coef = 0; // SI
                _matieres[5].coef = 0; // ISN
                _matieres[0].spe = false; // maths
                _matieres[1].spe = true; // PC
                _matieres[2].spe = false; // SVT
                _matieres[3].spe = false; // EAT
                // _matieres[4].spe = false; // SI jamais spé
                _matieres[5].spe = false; // ISN
                break;
              case 'ISN':
                _matieres[0].coef = 7; // maths
                _matieres[1].coef = 6; // PC
                _matieres[2].coef = 0; // SVT
                _matieres[3].coef = 7; // EAT
                _matieres[4].coef = 0; // SI
                _matieres[5].coef = 2; // ISN
                _matieres[0].spe = false; // maths
                _matieres[1].spe = false; // PC
                _matieres[2].spe = false; // SVT
                _matieres[3].spe = false; // EAT
                // _matieres[4].spe = false; // SI jamais spé
                _matieres[5].spe = true; // ISN
                break;
              case 'Écologie, agronomie et territoires':
                _matieres[0].coef = 7; // maths
                _matieres[1].coef = 6; // PC
                _matieres[2].coef = 0; // SVT
                _matieres[3].coef = 9; // EAT
                _matieres[4].coef = 0; // SI
                _matieres[5].coef = 0; // ISN
                _matieres[0].spe = false; // maths
                _matieres[1].spe = false; // PC
                _matieres[2].spe = false; // SVT
                _matieres[3].spe = true; // EAT
                // _matieres[4].spe = false; // SI jamais spé
                _matieres[5].spe = false; // ISN
                break;
              default:
                _matieres = [] as Matiere[];
                break;
            }
            break;
          case 'S-Sciences de l’ingénieur':
          default:
            switch (specialite) {
              case 'Mathématiques':
                _matieres[0].coef = 9; // maths
                _matieres[1].coef = 6; // PC
                _matieres[2].coef = 0; // SVT
                _matieres[3].coef = 0; // EAT
                _matieres[4].coef = 6; // SI
                _matieres[5].coef = 0; // ISN
                _matieres[0].spe = true; // maths
                _matieres[1].spe = false; // PC
                _matieres[2].spe = false; // SVT
                _matieres[3].spe = false; // EAT
                // _matieres[4].spe = false; // SI jamais spé
                _matieres[5].spe = false; // ISN
                break;
              case 'Physique - Chimie':
                _matieres[0].coef = 7; // maths
                _matieres[1].coef = 8; // PC
                _matieres[2].coef = 0; // SVT
                _matieres[3].coef = 0; // EAT
                _matieres[4].coef = 6; // SI
                _matieres[5].coef = 0; // ISN
                _matieres[0].spe = false; // maths
                _matieres[1].spe = true; // PC
                _matieres[2].spe = false; // SVT
                _matieres[3].spe = false; // EAT
                // _matieres[4].spe = false; // SI jamais spé
                _matieres[5].spe = false; // ISN
                break;
              case 'Aucune':
                _matieres[0].coef = 7; // maths
                _matieres[1].coef = 6; // PC
                _matieres[2].coef = 0; // SVT
                _matieres[3].coef = 0; // EAT
                _matieres[4].coef = 8; // SI
                _matieres[5].coef = 0; // ISN
                _matieres[0].spe = false; // maths
                _matieres[1].spe = false; // PC
                _matieres[2].spe = false; // SVT
                _matieres[3].spe = false; // EAT
                // _matieres[4].spe = false; // SI jamais spé
                _matieres[5].spe = false; // ISN
                break;
              case 'ISN':
                _matieres[0].coef = 7; // maths
                _matieres[1].coef = 6; // PC
                _matieres[2].coef = 0; // SVT
                _matieres[3].coef = 0; // EAT
                _matieres[4].coef = 6; // SI
                _matieres[5].coef = 2; // ISN
                _matieres[0].spe = false; // maths
                _matieres[1].spe = false; // PC
                _matieres[2].spe = false; // SVT
                _matieres[3].spe = false; // EAT
                // _matieres[4].spe = false; // SI jamais spé
                _matieres[5].spe = true; // ISN
                break;
              default:
                _matieres = [] as Matiere[];
                break;
            }
            break;
          }
          break;
      case 'L':
        _matieres = [...L.matieres_L];
        for (let i = 0; i < 12; i += 1) {
          _matieres[i].coef = 0;
          _matieres[i].spe = false;
        }
        _matieres[14].coef = L.COEF_LV2;
        _matieres[15].coef = L.COEF_LV1;
        _matieres[14].spe = false;
        _matieres[15].spe = false;
        switch (specialite) {
          case 'Langues et cultures de l\'antiquité: latin':
            _matieres[0].coef = L.COEF_SPE_4;
            _matieres[0].spe = true;
            break;
          case 'Langues et cultures de l\'antiquité: grec':
            _matieres[1].coef = L.COEF_SPE_4;
            _matieres[1].spe = true;
            break;
          case 'Langue vivante 3':
            _matieres[2].coef = L.COEF_SPE_4;
            _matieres[2].spe = true;
            break;
          case 'Mathématiques':
            _matieres[3].coef = L.COEF_SPE_4;
            _matieres[3].spe = true;
            break;
          case 'Droits et grands enjeux du monde contemporain':
            _matieres[4].coef = L.COEF_SPE_4;
            _matieres[4].spe = true;
            break;
          case 'LV1 approfondie':
            _matieres[14].coef = L.COEF_LV1_SISPE;
            _matieres[14].spe = true;
            break;
          case 'LV2 approfondie':
            _matieres[15].coef = L.COEF_LV2_SISPE;
            _matieres[15].spe = true;
            break;
          case 'Arts plastiques':
            _matieres[5].coef = L.COEF_SPE_3_3_ECRIT;
            _matieres[5].spe = true;
            break;
          case 'Cinéma-audiovisuel':
            _matieres[6].coef = L.COEF_SPE_3_3_ECRIT;
            _matieres[6].spe = true;
            break;
          case 'Histoire des arts':
            _matieres[7].coef = L.COEF_SPE_3_3_ECRIT;
            _matieres[7].spe = true;
            break;
          case 'Musique':
            _matieres[8].coef = L.COEF_SPE_3_3_ECRIT;
            _matieres[8].spe = true;
            break;
          case 'Théâtre':
            _matieres[9].coef = L.COEF_SPE_3_3_ECRIT;
            _matieres[9].spe = true;
            break;
          case 'Danse':
            _matieres[10].coef = L.COEF_SPE_3_3_ECRIT;
            _matieres[10].spe = true;
            break;
          case 'Arts du cirque':
            _matieres[11].coef = L.COEF_SPE_3_3_ECRIT;
            _matieres[11].spe = true;
            break;
          default:
            _matieres = [] as Matiere[];
            break;
        }
        break;
      default:
        _matieres = [] as Matiere[];
        break;
    }
    _changeEtapes(_matieres, 2);
  }, [specialite]);

  const _setChampInvalide = (): void => {
    for (const key of Object.keys(simulationBaseNotesVide)) {
      const a = simulation[key as keyof SimulationBaseNotes];
      if (a > 20 || a < 0) {
        setChampInvalide(true);
        return;
      }
    }
    for (const key of Object.keys(NotesTrimestreVide)) {
      for (let i = 0; i < 3; i += 1) {
        const a = simulation[key as keyof NotesTrimestre][i];
        if (a > 20 || a < 0) {
          setChampInvalide(true);
          return;
        }
      }
    }
    setChampInvalide(false);
  }
  useEffect(() => {
    if (!fromFB) {
      _setChampInvalide();
      let ptsEleve = 0;
      let ptsMaxEleve = 0;
      let note;

      for (let i = 0; i < matieresEA.length; i += 1) {
        if (simulation[matieresEA[i].name] !== '') {
          note = simulation[matieresEA[i].name] as number;
          ptsEleve += (matieresEA[i].pointsAuDessus10 ? Math.max(0, note - 10) : note) * matieresEA[i].coef;
          ptsMaxEleve += 20 * (matieresEA[i].pointsAuDessus10 ? 0 : matieresEA[i].coef);
        }
      }
      for (let i = 0; i < matieres.length; i += 1) {
        if (simulation[matieres[i].name] !== '') {
          note = simulation[matieres[i].name] as number;
          ptsEleve += (matieres[i].pointsAuDessus10 ? Math.max(0, note - 10) : note) * matieres[i].coef;
          ptsMaxEleve += 20 * (matieres[i].pointsAuDessus10 ? 0 : matieres[i].coef);
        }
      }
      // for (let i = 0; i < options.length; i += 1) {
      //   if (simulation[options[i].name] !== '') {
      //     note = simulation[options[i].name] as number;
      //     ptsEleve += (options[i].pointsAuDessus10 ? Math.max(0, note - 10) : note) * options[i].coef;
      //     ptsMaxEleve += 20 * (options[i].pointsAuDessus10 ? 0 : options[i].coef);
      //   }
      // }

      if (nb_options === '1' || nb_options === '2') {
        if (option_1 !== '' && option_1 > 10) {
          ptsEleve += (option_1 - 10) * (latin_ou_grec === 'Oui' ? COEF_OPTION1_LATIN_GREC : COEF_OPTION1);
        }
      }
      if (nb_options === '2') {
        if (option_2 !== '' && option_2 > 10) {
          ptsEleve += (option_2 - 10) * COEF_OPTION2;
        }
      }
      setFieldValue('points', ptsEleve);
      setFieldValue('nbTotalPoints', ptsMaxEleve);
    }
  }, [simulation]);

  useEffect(() => {
    if (arrowRightPressed) {
      if (boutonSuivant === undefined || boutonSuivant === 'oui')
      updateSimulationInLocalStorage(simulation);
      nextEtapeSaisie();
      setArrowRightPressed(false);
    }
    if (arrowLeftPressed) {
      previousEtapeSaisie();
      setArrowLeftPressed(false);
    }
    closePopup(true);
  }, [
    arrowRightPressed,
    arrowLeftPressed,
  ]);

  useEffect(() => {
    if (indexRubriqueSaisie === 3 && indexEtapeDansRubrique === 0 && nb_options !== '') {
      switch (nb_options) {
        case 'Aucune':
        changeAffichage(3, 1, false);
        changeAffichage(3, 2, false);
        changeAffichage(3, 3, false);
        break;
      case '1':
        changeAffichage(3, 1, true); // pas de latin ou grec en STMG
        // changeAffichage(3, 1, filiere !== 'STMG'); // pas de latin ou grec en STMG
        changeAffichage(3, 2, true);
        changeAffichage(3, 3, false);
        break;
      case '2':
      default:
        changeAffichage(3, 1, true); // pas de latin ou grec en STMG
        // changeAffichage(3, 1, filiere !== 'STMG'); // pas de latin ou grec en STMG
        changeAffichage(3, 2, true);
        changeAffichage(3, 3, true);
        break;
      }
      // const _options = [...options];
      // switch (nb_options) {
      //   case '1':
      //     _options[0].coef = COEF_OPTION1;
      //     _options[1].coef = COEF_OPTION2;
      //     break;
      //   case '2':
      //     _options[0].coef = COEF_OPTION1;
      //     _options[1].coef = 0;
      //     break;
      //   case 'Aucune':
      //     _options[0].coef = 0;
      //     _options[1].coef = 0;
      //   default:
      //     break;
      // }
      // _changeEtapes(_options, 3);
      nextEtapeSaisie();
    }
  }, [nb_options]);

  useEffect(() => {
    if (indexRubriqueSaisie === 3 && indexEtapeDansRubrique === 1 && latin_ou_grec !== '') {
      const _options = [...options];
      switch (latin_ou_grec) {
        case 'Oui':
          _options[0].coef = COEF_OPTION1_LATIN_GREC;
          break;
        case 'Non':
        default:
          _options[0].coef = COEF_OPTION1;
          break;
      }
      _changeEtapes(_options, 3);
      nextEtapeSaisie();
    }
  }, [latin_ou_grec]);

  useEffect(() => {
    let xDown = null as number | null;
    let yDown = null as number | null;

    const getTouches = (evt: TouchEvent): TouchList => {
      return evt.touches; // browser API
      // || evt.originalEvent.touches; // jQuery
    }

    const handleTouchStart = (evt: TouchEvent): void => {
      const firstTouch = getTouches(evt)[0];
      xDown = firstTouch.clientX;
      yDown = firstTouch.clientY;
    };

    // const handleTouchEnd = (evt: TouchEvent): void => {
    //   setEndSwipe(true);
    // };

    const handleTouchMove = (evt: TouchEvent): void => {
      if (!xDown || !yDown) {
        return;
      }

      const xUp = evt.touches[0].clientX;
      const yUp = evt.touches[0].clientY;

      const xDiff = xDown - xUp;
      const yDiff = yDown - yUp;
      // setXSwipe(xDiff);
      // setYSwipe(yDiff);

      if (Math.abs(xDiff) > Math.abs(yDiff)) {/*most significant*/
        if (xDiff > 0) {
          /* left swipe */
          // setArrowRightPressed(true);
        } else {
          /* right swipe */
          // setArrowLeftPressed(true);
        }
      } else {
        if (yDiff > 0) {
          /* up swipe */
        } else {
          /* down swipe */
        }
      }
      /* reset values */
      xDown = null;
      yDown = null;
    };

    window.addEventListener('touchstart', handleTouchStart, false);
    window.addEventListener('touchmove', handleTouchMove, false);

    return (): void => {
      window.removeEventListener('touchstart', handleTouchStart, false);
      window.removeEventListener('touchmove', handleTouchMove, false);
    };
  }, []);


  useEffect(() => {
    // console.log(indexRubriqueSaisie, indexEtapeDansRubrique);

    if (modifIndexes && etapesSaisie[indexRubriqueSaisie] && etapesSaisie[indexRubriqueSaisie].etapes[indexEtapeDansRubrique])
      setComposantAAfficher(etapesSaisie[indexRubriqueSaisie].etapes[indexEtapeDansRubrique].composant);
      setModifIndexes(false);
  }, [modifIndexes]);

  const classNameEntete = ['entete'];
  const classNamePopup = ['popup'];
  const classNamePopups =['popups'];
  if (popupCloseClass !== '') classNamePopups.push(popupCloseClass);

  return (
    <>
      <EtapesSaisieContext.Provider value={{
        ...etapesSaisieContextProps,
        directToEtapeSaisie: (etape: number): void => {}
      }}>
        <SaisieContext.Provider value={{
            modeAffichage,
            setModeAffichage,
            setArrowRightPressed,
            setArrowLeftPressed,
            boutonSuivant,
            setBoutonSuivant,
          }}
        >
          {(indexRubriqueSaisie === 0 && indexEtapeDansRubrique == 0) && <h2>au vu des annonces du ministre du 3 avril 2020</h2>}

          {dimensions.largeur > 900 && !fromFB && <BarreProgression />}
          {indexRubriqueSaisie > 0 &&
            <>
              <h2 className="bac">{`Bac ${filiere}`}</h2>
              <PointsNote />
            </>}
          {/* {(id !== -1 || beneficiaireSelectionne) &&  <BarreProgression />} */}


          <div id="page" className={pageUnmount}>

            {composantAAfficher}
            {/* {(id !== -1 || beneficiaireSelectionne) ? composantAAfficher : <Logo />} */}

            <div className={classNameEntete.join(' ')}>
              {/* <div>{xSwipe}</div> */}
              <div className="boutonsHaut">
                <div className="boutonGauche">
                  {(indexRubriqueSaisie !== 0 || indexEtapeDansRubrique !== 0) && !fromFB && <BoutonRetour />}
                  {/* {!modeAffichage && beneficiaireSelectionne && <BoutonAnnulerModifications />} */}
                  {/* {id !== -1 && modeAffichage && <BoutonSupprimer />} */}
                </div>
                <div className="boutonDroite">
                  {indexRubriqueSaisie < nbEtapesSaisie - 1
                    && <BoutonEtapeSuivante />}
                  {/* {!modeAffichage && beneficiaireSelectionne ? (
                    (indexRubriqueSaisie === 0 && id === -1) ? <BoutonCreerBeneficiaire />
                      : <BoutonValiderModifications />) : <CatchEnter />
                  } */}
                </div>
              </div>
            </div>

            <div className={classNamePopups.join(' ')}>
              {popupAffiche.map((element, index) => {
                return (
                  <div
                    key={`popup_${index}`}
                    id={`popup_${popupAffiche.length - index}`}
                  >
                    <div
                      key={`fond_popup_${index}`}
                      onClick={(): void => {
                        setEscapeDown(true);
                        setTimeout(() => setEscapeDown(false), 200);
                      }}
                      className="fond-inactif"
                      style={{ zIndex: 2005 + 10 * index }}
                    />
                    <div
                      key={`popup_container_content_${index}`}
                      className={classNamePopup.join(' ')}
                      style={{ zIndex: 2010 + 10 * index }}
                    >
                      <div /* ref={refPopup} */
                        key={`popup_contenu_${index}`}
                      >
                        {element}
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>

          </div>
        </SaisieContext.Provider>
      </EtapesSaisieContext.Provider>
    </>
  );
};
